"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _PanelItems = require("./PanelItems.style");
var _menuItems = require("../../../../../../constants/menuItems");
var _getShowHomepageToggle = _interopRequireDefault(require("../../../../../../utils/getShowHomepageToggle"));
var _withAppConfig = _interopRequireDefault(require("../../../../../HOCs/withAppConfig"));
var _withHeaderApi = _interopRequireDefault(require("../../../../../HOCs/withHeaderApi"));
var _withUserAndPreferences = _interopRequireDefault(require("../../../../../HOCs/withUserAndPreferences"));
var _HomePageToggle = _interopRequireDefault(require("../../../../../HomePageToggle"));
var _Text = _interopRequireDefault(require("../../../../../Text"));
var _Functionality = _interopRequireDefault(require("../../../../Desktop/NavItem/Functionality"));
const FooterPanelItems = _ref => {
  let {
    section,
    subMenu,
    data
  } = _ref;
  const showHomepageToggle = (0, _getShowHomepageToggle.default)(data);
  return /*#__PURE__*/_react.default.createElement(_PanelItems.Wrapper, {
    "data-test-id": "res-service-menu-".concat(section.toLowerCase(), "-submenu")
  }, subMenu && subMenu.map((_ref2, index) => {
    let {
      type,
      link,
      newTab,
      text,
      icon,
      customRender
    } = _ref2;
    if (!showHomepageToggle && customRender === _menuItems.CUSTOM_DROPDOWN_NEW_HOME_TOGGLE) return null;
    const key = "".concat(text, "_").concat(icon);
    return /*#__PURE__*/_react.default.createElement(_PanelItems.ItemWrapper, {
      key: key,
      noBorder: index === subMenu.length - 1
    }, /*#__PURE__*/_react.default.createElement(_Functionality.default, {
      type: type,
      link: link,
      newTab: newTab,
      "data-test-id": "res-service-menu-".concat(key.toLowerCase())
    }, customRender === _menuItems.CUSTOM_DROPDOWN_NEW_HOME_TOGGLE && /*#__PURE__*/_react.default.createElement(_HomePageToggle.default, {
      id: "new-homepage-toggle",
      key: "newHomepageToggle"
    }), text && !customRender && /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "Body",
      variant: "BoldBlack",
      intlText: text
    })));
  }));
};
var _default = exports.default = (0, _flowRight.default)(_withAppConfig.default, _withHeaderApi.default, _withUserAndPreferences.default)(FooterPanelItems);